@if ((auth.isAuthenticated$ | async) === false) {
  <div class="container">
    <mat-card appearance="outlined" class="box" style="overflow: hidden">
      <mat-card-content>
        <div class="item">
          <img mat-card-image class="logo-img" src="{{ logoURL }}" alt="OEM logo" />
        </div>
        <div class="item">
          @if (isLoading) {
            <app-skeleton></app-skeleton>
          }
          @if (!isLoading) {
            <div class="container-btn">
              @if ((auth.isAuthenticated$ | async) === false) {
                <button
                  class="btn button-primary"
                  mat-flat-button
                  (click)="login()"
                  (keydown.enter)="login()"
                  (keydown.space)="login()"
                  data-cy="login"
                >
                  {{ 'NAVBAR.LOGIN' | translate }}
                </button>
              }
              <div class="spacer">
                <div class="line"></div>
                <span>{{ 'LOGIN.OR' | translate }}</span>
                <div class="line"></div>
              </div>
              <button
                class="btn button-primary"
                mat-flat-button
                (click)="signup()"
                (keydown.enter)="signup()"
                (keydown.space)="signup()"
                data-cy="register"
              >
                {{ 'NAVBAR.SIGNUP' | translate }}
              </button>
            </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}
